export default "__VITE_ASSET__BxqzdBS7__"